import { render, staticRenderFns } from "./staRecharge.vue?vue&type=template&id=0c8ce27c&scoped=true&"
import script from "./staRecharge.vue?vue&type=script&lang=js&"
export * from "./staRecharge.vue?vue&type=script&lang=js&"
import style0 from "./staRecharge.vue?vue&type=style&index=0&id=0c8ce27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ce27c",
  null
  
)

export default component.exports